export function looksLikeLogoUrl(url: string): boolean {
  return /logo|logotype|storymfg_rgb|satisfy.*social|hat_label|anerkjendt\.com\/cdn\/shop\/files\/frame_1|\.svg(?:\?|$)/i.test(url);
}

export function classifyLoadedBrandImage(img: HTMLImageElement): "photo" | "logo" {
  if (looksLikeLogoUrl(img.currentSrc)) return "logo";
  if (!img.naturalWidth || !img.naturalHeight) return "photo";

  const ratio = img.naturalWidth / img.naturalHeight;
  const isLogoLike = ratio > 2.4 || ratio < 0.65 || Math.max(img.naturalWidth, img.naturalHeight) < 720;
  if (isLogoLike) return "logo";

  try {
    const canvas = document.createElement("canvas");
    const sample = 32;
    canvas.width = sample;
    canvas.height = sample;
    const ctx = canvas.getContext("2d");
    if (!ctx) return "photo";
    ctx.drawImage(img, 0, 0, sample, sample);
    const data = ctx.getImageData(0, 0, sample, sample).data;
    let brightSum = 0;
    let alphaSum = 0;
    let transparent = 0;
    let dark = 0;
    let nearBlack = 0;
    let colorDeltaSum = 0;
    let count = 0;
    for (let i = 0; i < data.length; i += 4) {
      const lum = 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
      brightSum += lum;
      count++;
      alphaSum += data[i + 3];
      if (data[i + 3] < 24) transparent++;
      if (lum < 34) dark++;
      if (lum < 18) nearBlack++;
      colorDeltaSum += Math.max(data[i], data[i + 1], data[i + 2]) - Math.min(data[i], data[i + 1], data[i + 2]);
    }

    const avg = brightSum / count;
    const avgAlpha = alphaSum / count;
    const transparentRatio = transparent / count;
    const darkRatio = dark / count;
    const nearBlackRatio = nearBlack / count;
    const avgColorDelta = colorDeltaSum / count;
    const darkMonochromeLogo = avg < 58 && darkRatio > 0.5 && avgColorDelta < 24;
    const almostInvisibleOnDark = avg < 28 && nearBlackRatio > 0.72;
    return avgAlpha < 230 || transparentRatio > 0.25 || darkMonochromeLogo || almostInvisibleOnDark ? "logo" : "photo";
  } catch {
    return "photo";
  }
}
